(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mvv_quemsomos"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';

    document.addEventListener('DOMContentLoaded', function() {
      initMVVSection();
    });

    function initMVVSection() {
      const mvvItems = document.querySelectorAll('.js-mvv-item');

      if (! mvvItems.length) return;
      

      animateItemsOnScroll(mvvItems);

      mvvItems.forEach(function(item) {
        item.addEventListener('mouseenter', handleItemHover);
        item.addEventListener('mouseleave', handleItemLeave);
      });
    }

    function animateItemsOnScroll(items) {
      if (!('IntersectionObserver' in window)) return;
      

      const observerOptions = {
        root: null,
        threshold: 0.2,
        rootMargin: '0px'
      };

      const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry, index) {
          if (entry.isIntersecting) {
            setTimeout(function() {
              entry.target.classList.add('is-visible');
            }, index * 150);

            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);

      items.forEach(function(item) {
        observer.observe(item);
      });
    }

    function handleItemHover(e) {
      const item = e.currentTarget;
      item.classList.add('is-active');
    }

    function handleItemLeave(e) {
      const item = e.currentTarget;
      item.classList.remove('is-active');
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["used-equipment-list"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('section[id^="UsedEquipment-"]').forEach((section) => {
        const live = section.querySelector('.used-equip [id^="used-equip-live-"]');

        section.querySelectorAll('.used-equip__copy').forEach((btn) => {
          btn.addEventListener('click', () => {
            const article = btn.closest('article');
            const lines = [];
            const title = article?.querySelector('.used-equip__title')?.textContent?.trim();
            if (title) lines.push(title);
            lines.push('Especificações:');
            article?.querySelectorAll('.used-equip__row').forEach((row) => {
              const label = row.querySelector('.used-equip__label')?.textContent?.replace(/\s+/g, ' ').trim();
              const value = row.querySelector('.used-equip__value')?.textContent?.replace(/\s+/g, ' ').trim();
              if (label && value) lines.push(`${label} ${value}`);
            });
            const text = lines.join('\n');

            const announce = (msg) => {
              if (!live) return;
              live.textContent = '';
              requestAnimationFrame(() => (live.textContent = msg));
            };

            const fallback = () => {
              const ta = document.createElement('textarea');
              ta.value = text;
              ta.setAttribute('readonly', '');
              ta.style.position = 'fixed';
              ta.style.opacity = '0';
              document.body.appendChild(ta);
              ta.select();
              try {
                document.execCommand('copy');
                announce('Especificações copiadas.');
              } catch (e) {
                announce('Falha ao copiar.');
              } finally {
                document.body.removeChild(ta);
              }
            };

            if (navigator.clipboard && window.isSecureContext) {
              navigator.clipboard
                .writeText(text)
                .then(() => announce('Especificações copiadas.'))
                .catch(fallback);
            } else {
              fallback();
            }
          });
        });

        section.querySelectorAll('.used-equip__media').forEach((media) => {
          const img = media.querySelector('img');
          if (!img) return;
          let added = false;
          const add = () => {
            if (!added) {
              media.classList.add('skeleton');
              added = true;
            }
          };
          const remove = () => {
            media.classList.remove('skeleton');
            added = false;
          };
          if (img.complete) {
            remove();
          } else {
            const id = setTimeout(add, 600);
            img.addEventListener(
              'load',
              () => {
                clearTimeout(id);
                remove();
              },
              { once: true }
            );
            img.addEventListener(
              'error',
              () => {
                clearTimeout(id);
                remove();
              },
              { once: true }
            );
          }
        });
      });
    });
  
  } catch(e) { console.error(e); }
})();
})();
